import { runtimeConfig } from "@src/runtime-config";

/** Whether the app is running on production or not (staging or dev), localhost on production also returns true */
export const isProductionEnvironment =
  runtimeConfig.environment === "production";
